export function monthLabel(month, locale) {
  const m = Number(month);
  if (!m || m < 1 || m > 12) return String(month);
  const loc = locale === "en" ? "en-US" : "de-DE";
  return new Date(2000, m - 1, 1).toLocaleString(loc, { month: "long" });
}
